import { t } from '@lingui/core/macro';
import { DateRangeFilter } from './DateFilter';
export const dateSignedFilterLabel = () => t({
    message: 'Date signed',
    comment: 'Insights: Date signed date filter',
});
export function DateSignedFilter() {
    return <DateRangeFilter name="metadataDocumentDateSigned" label={dateSignedFilterLabel()}/>;
}
